export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.oceansbluee.com/api';

//https://api.oceansbluee.com/api
//http://localhost:5170/api

export const MODULE_IDS = {
  READY_PRODUCT: 1,
  RAW_MATERIAL: 2,
  MAPPING: 3,
  VENDOR: 4,
  RAW_PURCHASE: 5,
  PRODUCTION: 6,
  CONSUMPTION: 7,
  USER_MGMT: 8,
  REPORTS: 9
};

export const GST_RATES = [
  { label: '0%', value: 0 },
  { label: '5%', value: 5 },
  { label: '12%', value: 12 },
  { label: '18%', value: 18 },
  { label: '28%', value: 28 }
];

export const STOCK_THRESHOLD = 10;